__turbopack_context__.v({
  "carouselWrapper": "_5pDAHW_carouselWrapper",
  "h2": "_5pDAHW_h2",
  "headerInfoMobile": "_5pDAHW_headerInfoMobile",
  "mblPriceContainer": "_5pDAHW_mblPriceContainer",
  "titleContainer": "_5pDAHW_titleContainer",
});
